import ServerApi from "./../../libs/api-services/server-api"

class SearchService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/maps/"

  async loadObjectsForPrcID(PRC_ID: string) {
    return await this.get(`/v1/secure/user/maps/prcid/${PRC_ID}/objects`)
  }
  async loadFullDetailsForPrcID(PRC_ID: string) {
    return await this.get(`/v1/secure/user/maps/prcid/${PRC_ID}/objects-full`)
  }

  async search(searchQuery, searchQueryObject, typeOfSearch) {
    if (typeOfSearch == "advance") {
      return await this.get(`/v1/secure/user/maps/advance-search?a=1&${searchQueryObject}`)
    }
    return await this.get(`/v1/secure/user/maps/search?searchQuery=${searchQuery}&${searchQueryObject}`)
  }

  async getAIReportOneTimeToken(prcid) {
    return await this.get(`/v1/secure/user/maps/ai-report-token/${prcid}`)
  }
  async getReportDownloadOneTimeToken(prcid) {
    return await this.get(`/v1/secure/user/maps/report-download-token/${prcid}`)
  }

  getAIReportURL(){
    return `${this.URL_PREFIX}ai-report`
  }

  calculateBounds(points) {
    let minX, maxX, minY, maxY

    points.forEach((p, i) => {
      if (i === 0) {
        minX = maxX = p[0]
        minY = maxY = p[1]
      } else {
        minX = Math.min(p[0], minX)
        minY = Math.min(p[1], minY)
        maxX = Math.max(p[0], maxX)
        maxY = Math.max(p[1], maxY)
      }
    })

    return {minX, maxX, minY, maxY}
  }
}

export const searchService = new SearchService()
